import React from 'react'
import { i18nTranslate } from 'src/utils'
// import { Trans } from 'react-i18next'
import { Button } from 'react-bootstrap'
import { Card, Form, ListGroup, Row, Col } from 'react-bootstrap'
import { Icons } from 'src/views/components'
import { catalogDeps, productDeps } from 'src/deps'
import {
  checkEnableButton,
  checkCustomerTypeEligibility,
  modifyAndGetAccountType,
  modifyAndGetCustomerType,
} from 'src/utils'
import {
  catalogContainer,
  nuskinSubscriptionContainer,
  subscriptionContainer,
  cartContainer,
  customerContainer,
} from 'src/models'
import { getImageFromProperty } from 'src/utils'
import SingleProductSubscriptionModal from 'src/views/components/SubscriptionComponents/SingleProductSubscriptionModal'
import get from 'lodash/get'
import { observable } from 'mobx'
import { minimumSearchCharLength, APPConfig } from 'config/appConfig'
import { observer } from 'mobx-react'
import { toastState, overlayState, ImageComponent } from 'src/views/components'
import isArray from 'lodash/isArray'
import debounce from 'lodash/debounce'
import './styles.scss'
import { notAllowDangerousGoodsToCart } from 'src/utils'

@observer
class SubscriptionInfiniteScroll extends React.Component {
  @observable productSuggestions = []
  @observable isSearchApiInProgress = true
  @observable inputValue = ''
  @observable height = 70
  @observable page = 1
  @observable size = 5
  @observable totalCount = 0
  @observable isActive = false
  @observable isListening = false
  @observable skuIdToBeAddedInSubscription = ''
  @observable showSingleProductModal = false
  selectedProductDetails = {}
  constructor(props, context) {
    super(props)
  }

  toggleSingleSubscribeProductModal = () => {
    this.showSingleProductModal = !this.showSingleProductModal
  }

  doSubscribe = data => {
    const {
      product,
      product: { skuDetails },
      product: { skuId },
      quantity,
      frequency: frequencyPeriod,
      frequencyOrder = 'VARIABLE_MULTI_ORDER',
      isOneTimeFrequency = false,
    } = data

    this.handleItemClick(
      product,
      skuDetails,
      skuId,
      quantity,
      frequencyPeriod,
      data,
      frequencyOrder,
      isOneTimeFrequency
    )

    this.toggleSingleSubscribeProductModal()
  }

  openSingleSubscribeProductModal = async (
    product = {},
    productDetails = {},
    skuId = '',
    isFromDashboard = false
  ) => {
    if (
      ['bundle', 'kit'].indexOf(
        product && product.type ? product.type.toLowerCase() : ''
      ) > -1
    ) {
      const response = await catalogContainer.getProduct({
        productId: product?.identifier,
      })

      this.selectedProductDetails = {
        ...(response?.product?.[0] || {}),
        ...(response?.product?.[0]?.properties || {}),
        productId: response?.product?.[0]?.identifier || '',
        isBundle: true,
        categoryId: response?.category?.identifier || '',
        isFromDashboard: isFromDashboard,
      }
    } else {
      this.selectedProductDetails = {
        ...(product || {}),
        ...(productDetails?.properties || {}),
        transactionPrice: productDetails?.prices?.[0] || {},
        skuId: skuId || '',
        skuDetails: productDetails || {},
        productDetails,
        isFromDashboard: isFromDashboard,
      }
    }

    this.toggleSingleSubscribeProductModal()
  }

  getProductResponse = async () => {
    const searchTerm = this.inputValue.trim()
    /*const filterValue = [
      {
        field: 'facet_availableforsubscriptions',
        operation: 'IN',
        value: 'true',
      },
    ]*/
    const filterValue = {
      filters: [
        {
          field: 'index_string_productStatus',
          operation: 'NOTIN',
          value: 'bundleOnly,replacement,discontinued',
        },
      ],
    }
    const response = await catalogContainer.getSearchProducts({
      queryParams: {
        searchTerm,
        page: this.page,
        skipSearchContentful: true,
      },
      size: this.size,
      filterValue,
    })
    return response
  }
  loadMoreData = async () => {
    if (this.inputValue.trim().length >= minimumSearchCharLength) {
      const response = await this.getProductResponse()
      this.productSuggestions = [
        ...this.productSuggestions,
        ...(response?.product || []),
      ]
    }
  }
  handlerScroll = e => {
    if (
      e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop <
      1
    ) {
      if (this.totalCount > 5) {
        this.page = this.page + 1
        this.loadMoreData()
      }
    }
  }

  /*getFrequencyDetails = skuDetails => {
    // to get intervalDetails from response
    const productProperties = get(skuDetails, 'properties') || {}
    this.frequencyOptionList = getFrequencyList(productProperties)
    let frequencyValue = []
    if (this.frequencyOptionList.length > 0) {
      const frequency = this.frequencyOptionList[0].value
      frequencyValue = frequency && frequency.split('-')
    }
    return frequencyValue
  }*/

  handleSubscriptionAddToBag = (
    product = {},
    skuDetails = {},
    quantity = 1,
    frequencyPeriod = 1,
    frequencyOrder = 'VARIABLE_MULTI_ORDER'
  ) => {
    const skuId = skuDetails?.identifier || ''
    const productId = product?.identifier || ''
    const categoryName = product?.properties?.categoryName || ''
    //const frequencyDetails = this.getFrequencyDetails(skuDetails)
    if (skuId) {
      return [
        {
          skuId: skuId,
          productId: productId,
          quantity: quantity,
          frequencyPeriod: frequencyPeriod,
          frequencyType: 'MONTHS',
          isPVReserved: this.props.isPvAssistPage ? true : false,
          isSubscriptionPreference: true,
          category: categoryName,
          frequencyOrder,
        },
      ]
    }
    return []
  }
  handlePvItemClick = async (product, skuDetails, skuId) => {
    if (
      subscriptionContainer.selectedPvItems &&
      subscriptionContainer.selectedPvItems.length < 20
    ) {
      this.skuIdToBeAddedInSubscription = skuId
      let cartArray = this.handleSubscriptionAddToBag(product, skuDetails)
      let response = await subscriptionContainer.addToSubscription(cartArray)
      if (subscriptionContainer.isSuccessResponse(response)) {
        this.handleClear()
        this.props.handleSubscription()
        this.props.selectedItemSkuId(response)
      } else {
        toastState.setToastMessage(response.message || '')
      }
      this.skuIdToBeAddedInSubscription = ''
    }
  }

  handleQuickView = product => {
    const productId = product?.productId || product?.identifier
    this.props.handleBundleView(productId, '')
  }

  handleItemClick = async (
    product = {},
    skuDetails = {},
    skuId = '',
    quantity = 1,
    frequencyPeriod = 1,
    modalData,
    frequencyOrder = 'VARIABLE_MULTI_ORDER',
    isOneTimeFrequency = false
  ) => {
    if (
      ['bundle', 'kit'].indexOf(
        product && product.type ? product.type.toLowerCase() : ''
      ) > -1
    ) {
      const postParameters =
        nuskinSubscriptionContainer.getPostBodyForAddSubscription(modalData)

      if (postParameters && postParameters[0]) {
        postParameters[0].isSubscriptionPreference = true
      }
      product.isFromDashboard && overlayState.toggleLoader()
      let response = await nuskinSubscriptionContainer.addSubscription(
        postParameters,
        product
      )

      if (subscriptionContainer.isSuccessResponse(response)) {
        if (isOneTimeFrequency) {
          toastState.setToastMessage(
            i18nTranslate(
              'subscription.successItemOneTime',
              'Item will only ship once with next shipment. Shipment must include subscribed items in order to process.'
            ),
            true
          )
        } else {
          toastState.setToastMessage(
            i18nTranslate(
              'subscription.successItem',
              'Item(s) successfully added to subscription'
            ),
            true
          )
        }
        this.handleClear()
        await this.props.handleSubscription()
        if (customerContainer.isRegisterUser)
          await cartContainer.getSubscriptionCount()
        this.props.selectedItemSkuId(product?.identifier || '')
        product.isFromDashboard && overlayState.toggleLoader()
      } else {
        product.isFromDashboard && overlayState.toggleLoader()
      }
      return
    }
    this.skuIdToBeAddedInSubscription = skuId
    let cartArray = this.handleSubscriptionAddToBag(
      product,
      skuDetails,
      quantity,
      frequencyPeriod,
      frequencyOrder
    )
    product.isFromDashboard && overlayState.toggleLoader()
    let response = await subscriptionContainer.addToSubscription(cartArray)
    if (subscriptionContainer.isSuccessResponse(response)) {
      if (isOneTimeFrequency) {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.successItemOneTime',
            'Item will only ship once with next shipment. Shipment must include subscribed items in order to process.'
          ),
          true
        )
      } else {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.successItem',
            'Item(s) successfully added to subscription'
          ),
          true
        )
      }
      this.handleClear()
      await this.props.handleSubscription()
      if (customerContainer.isRegisterUser)
        await cartContainer.getSubscriptionCount()
      this.props.selectedItemSkuId(skuDetails?.identifier || '')
    } else if (
      (response.code && response.code == 'YLSHIPPING_COMMON') ||
      (isArray(response.errors) &&
        response.errors[0].code == 'YLSHIPPING_COMMON')
    ) {
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.shippingRestriction',
          'This item has special shipping requirements. It has shipping restrictions and can not be shipped to your default address. Please change your shipping address.'
        ),
        false
      )
    } else if (response.code && response.code == 'EOGLOB0001') {
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.paymentIssue',
          'You currently do not have a payment method associated with subscriptions. Please add a payment method'
        )
      )
    } else {
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const responseErrorMessage =
        response?.responseMessage || response?.message || ''
      const errorMessage = editFreezeErrorCode
        ? i18nTranslate(
            'subscription.editFreezeErrorMessage',
            'This subscription order is currently being processed and at this time no changes will be allowed. Please return after your subscription order has shipped to make any changes to your next order.'
          )
        : responseErrorMessage
      toastState.setToastMessage(errorMessage)
    }
    product.isFromDashboard && overlayState.toggleLoader()
    this.skuIdToBeAddedInSubscription = ''
  }

  getPdtImage = (product = {}) => {
    // if (isMerchPLP) {
    //   const { currentIndex, images } = this.imageArrayProperties
    //   return images[currentIndex]
    // } else
    if (product?.type == 'kit' || product?.type === 'bundle') {
      return getImageFromProperty(product?.properties)
    }
    const defaultSku = catalogDeps.getDefaultSelectedSku(product)
    return getImageFromProperty(defaultSku?.[0]?.properties)
  }

  renderDropDown = () => {
    if (!this.isSearchApiInProgress) {
      const filteredProducts =
        this.productSuggestions?.filter(product => {
          const isBundle = productDeps.isBundleData(product)
          const availableChannels = isBundle
            ? product?.properties?.availableChannels || ''
            : product?.sku?.[0]?.properties?.availableChannels || ''
          if (checkEnableButton(availableChannels, 'subscription')) {
            let accoutTypeResult =
              modifyAndGetAccountType(
                customerContainer?.profileResponse?.accounts?.accountType
              ) || ''
            const customerTypeResult =
              modifyAndGetCustomerType(
                product?.sku?.[0]?.properties?.customerTypes
              ) || ''
            const isCustomerEligible = checkCustomerTypeEligibility(
              customerTypeResult,
              accoutTypeResult
            )
            const isProuctAvailable =
              product?.sku?.[0]?.inventory?.toLowerCase() !== 'unavailable'
            return isCustomerEligible && isProuctAvailable
          } else {
            return false
          }
        }) || []

      if (
        typeof filteredProducts != 'undefined' &&
        filteredProducts.length == 0
      ) {
        if (this.inputValue.length >= minimumSearchCharLength) {
          const searchNoResults = i18nTranslate(
            'subscription.searchNoResults',
            'No Results Found'
          )
          return (
            <div className="dropdown-subscription">
              <div className="subscription-result">
                <Card className="subs-input-card">
                  <Card.Body className="p-2">
                    <Row className="infinite-search-custom-row m-0">
                      <Col className="pl-0">
                        <div className="custom-infinite-scroll">
                          <strong>{searchNoResults}</strong>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </div>
            </div>
          )
        }
        return null
      } else {
        // const subscriptionProducts =
        //   subscriptionContainer?.subscriptionShowAllDeliveryStatus?.subscriptions
        //     ?.subscriptions || []
        const searchCardAdd = i18nTranslate('subscription.searchCardAdd', 'ADD')
        const searchCardAdded = i18nTranslate(
          'subscription.searchCardAdded',
          'ADDED'
        )
        const searchCardOOS = i18nTranslate('subscription.searchCardOOS', 'OOS')
        const searchCardUnavailable = i18nTranslate(
          'subscription.searchCardUnavailable',
          'Unavailable'
        )
        return (
          <div className="dropdown-subscription" id="dropdownsubscriptionId">
            <div
              className="subscription-result"
              id="subscription-result-id"
              onScroll={this.handlerScroll}
              style={{ overflowY: 'auto' }}>
              {typeof filteredProducts != 'undefined' &&
                filteredProducts.length > 0 &&
                filteredProducts.map((product, index) => {
                  if (
                    typeof product.type == 'undefined' ||
                    !['fixedpricebundle', 'collection'].includes(
                      product.type.toLowerCase()
                    )
                  ) {
                    let btnLabel = searchCardAdd
                    const selectedSKU =
                      catalogDeps.getDefaultSelectedSku(product)
                    const productDetails = selectedSKU[0] || product || {}
                    const name =
                      get(productDetails, 'properties.name', '') ||
                      get(product, 'properties.name', '')
                    const imageURL = this.getPdtImage(product)
                    const variant =
                      get(productDetails, 'properties.variant', '') ||
                      get(product, 'properties.variant', '') ||
                      get(product, 'identifier', '')
                    const itemValue = productDetails?.identifier || ''
                    const isStarterKit =
                      productDetails?.properties?.isstarterkit || '' === 'true'
                        ? true
                        : false
                    const inventoryStatus = productDetails?.inventory || ''
                    const availableInStore =
                      productDetails?.properties?.availableinstore || ''
                    const isAvailableInStore = availableInStore === '0'
                    const isInActiveItem =
                      availableInStore === '3' || availableInStore === '5'
                        ? true
                        : false
                    const isOOSItem =
                      inventoryStatus?.toLowerCase() === 'out of stock' || false
                    const dangerousGoods =
                      (productDetails?.skuProperties?.dangerousGoods ===
                        'true' ||
                      productDetails?.properties?.dangerousGoods === 'true' ||
                      product?.properties?.dangerousGoods === 'true') && notAllowDangerousGoodsToCart()
                    let isItemSubscribed = false
                    if (!this.props.isPvAssistPage) {
                      // subscriptionProducts.forEach((subscriptionItem, index) => {
                      //   let subscriptionItemValue =
                      //     subscriptionItem?.itemInfo?.[0]?.skus?.[0]?.id || ''
                      //   if (subscriptionItemValue === itemValue) {
                      //     isItemSubscribed = true
                      //   }
                      // })

                      const totalSubscriptionCount =
                        cartContainer.subscriptionResponse
                          ?.totalSubscriptionCount || 0
                      if (totalSubscriptionCount) {
                        const isBundle =
                          ['bundle', 'kit'].indexOf(
                            product && product.type
                              ? product.type.toLowerCase()
                              : ''
                          ) > -1
                        if (isBundle) {
                          let mandatoryProductIds =
                            product?.bundlemandatoryproductids ||
                            product?.identifier ||
                            ''

                          isItemSubscribed =
                            nuskinSubscriptionContainer.subscriptionData
                              ?.subscriptions &&
                            nuskinSubscriptionContainer.subscriptionData.subscriptions.some(
                              item => {
                                let skus =
                                  (item?.itemInfo?.length &&
                                    item?.itemInfo?.[0]?.skus) ||
                                  []
                                return skus.some(sku => {
                                  return mandatoryProductIds?.indexOf(
                                    sku?.productId
                                  ) > -1
                                    ? true
                                    : false
                                })
                              }
                            )
                        } else {
                          const skuId = itemValue
                          isItemSubscribed =
                            nuskinSubscriptionContainer.subscriptionData
                              .subscriptions &&
                            nuskinSubscriptionContainer.subscriptionData.subscriptions.some(
                              item => {
                                const id =
                                  item?.itemInfo?.[0].skus?.[0]?.id || ''
                                return id == skuId
                              }
                            )
                        }
                      }
                    }

                    if (isItemSubscribed) {
                      btnLabel = searchCardAdded
                    } else if (isInActiveItem) {
                      btnLabel = searchCardOOS
                    } else if (isOOSItem) {
                      btnLabel = searchCardAdd
                    } else if (isStarterKit || isAvailableInStore) {
                      btnLabel = searchCardUnavailable
                    }

                    const skuId =
                      get(productDetails, 'identifier', '') ||
                      get(product, 'identifier', '') ||
                      ''
                    const isToDisableAddButton =
                      skuId === this.skuIdToBeAddedInSubscription ||
                      isStarterKit ||
                      isInActiveItem ||
                      dangerousGoods ||
                      isAvailableInStore ||
                      btnLabel === searchCardAdded
                    const showSearchSuggestionImage =
                      APPConfig?.getAppConfig()?.showSearchSuggestionImage ===
                      'true'
                    return (
                      <Card className="subs-input-card" key={index}>
                        <ListGroup variant="flush">
                          <ListGroup.Item className="p-0" key={index}>
                            <Card.Body className="p-2">
                              <Row
                                className={`infinite-search-custom-row m-0 ${
                                  showSearchSuggestionImage
                                    ? 'with-image'
                                    : 'without-image'
                                }`}>
                                {showSearchSuggestionImage && (
                                  <ImageComponent
                                    testid="qa-product-search-image"
                                    overrideParentClass={true}
                                    customParentClassName="product-search-wrapper mr-2"
                                    className="product-search-image"
                                    src={imageURL || ''}
                                    alt={name}
                                    optimizeImage={true}
                                    height={'50px'}
                                    width={'50px'}
                                  />
                                )}
                                <Col className="pl-0 search-text-section">
                                  <div className="custom-infinite-scroll">
                                    <strong>{name}</strong>
                                    <p className="m-0">
                                      {/* <span>{variant}</span>  CX15-9055-  identifiers should not be shown*/}
                                      #<span>{itemValue}</span>
                                    </p>
                                  </div>
                                </Col>
                                <Col className="pr-0 pl-0 infinite-search-add-button-wrapper">
                                  <Button
                                    className="float-right infinite-search-add-button"
                                    variant="primary"
                                    style={{
                                      backgroundColor:
                                        isInActiveItem ||
                                        isStarterKit ||
                                        isAvailableInStore
                                          ? '#BE1217'
                                          : btnLabel == searchCardAdded
                                          ? '#89b59b'
                                          : '#126B37',
                                    }}
                                    disabled={isToDisableAddButton}
                                    onClick={() =>
                                      this.props.isPvAssistPage
                                        ? this.handlePvItemClick(
                                            product,
                                            productDetails,
                                            skuId
                                          )
                                        : this.openSingleSubscribeProductModal(
                                            product,
                                            productDetails,
                                            skuId,
                                            true
                                          )
                                    }>
                                    {btnLabel}
                                    {btnLabel == searchCardAdd ? (
                                      <Icons
                                        name={'CRUD'}
                                        icontype={'plus'}
                                        color="white"
                                        className="ml-1 mb-1"
                                        width="14px"
                                      />
                                    ) : btnLabel == searchCardAdded ? (
                                      <Icons
                                        name={'CRUD'}
                                        icontype={'tick'}
                                        color="white"
                                        className="ml-1"
                                        width="14px"
                                      />
                                    ) : (
                                      <Icons
                                        name={'header-icons'}
                                        icontype={'close-circle'}
                                        color="white"
                                        className="ml-1"
                                        width="14px"
                                      />
                                    )}
                                  </Button>
                                  {dangerousGoods && (
                                    <span className="text-bundle-danger msg-style">
                                      {i18nTranslate(
                                        'pdp.dangerousGoodsError',
                                        'Dangerous Goods cannot be added to Cart or Subscribed',
                                        {
                                          nameSpace: 'ssr-resource',
                                        }
                                      )}
                                    </span>
                                  )}
                                </Col>
                              </Row>
                            </Card.Body>
                          </ListGroup.Item>
                        </ListGroup>
                      </Card>
                    )
                  }
                })}
            </div>
          </div>
        )
      }
    } else {
      return <></>
    }
  }

  handleInputChange = event => {
    this.inputValue = event.target.value
    if (this.inputValue.trim().length >= minimumSearchCharLength) {
      //make the call to api and fetch the response and assign it to the userSuggestion
      this.isSearchApiInProgress = true
      this.debounceQuickAddProduct()
    } else {
      this.productSuggestions = []
      this.page = 1
    }
  }

  debounceQuickAddProduct = debounce(async () => {
    this.page = 1
    // page resetting is done here when call is made for new search keyword
    const response = await this.getProductResponse()
    this.productSuggestions = response?.product || []
    this.totalCount = response?.pageableInfo?.totalCount || 0
    this.isSearchApiInProgress = false
  }, 700)

  setRef = node => {
    this.searchContainerNode = node
  }
  disableListener = () => {
    if (this.isListening === true) {
      if (typeof window === 'object') {
        window.removeEventListener('click', this.handleOutsideClick)
        this.isListening = false
      }
    }
  }
  handleOutsideClick = event => {
    if (
      this.searchContainerNode &&
      !this.searchContainerNode.contains(event.target)
    ) {
      this.isActive = false
      this.handleClear()
      this.disableListener()
    }
  }
  enableListener = () => {
    if (this.isActive === true && this.isListening === false) {
      if (typeof window === 'object') {
        window.addEventListener('click', this.handleOutsideClick)
        this.isListening = true
      }
    }
  }
  handleBoundaryBlur = () => {
    this.isActive = true
    this.enableListener()
  }
  handleClear = () => {
    this.inputValue = ''
    this.productSuggestions = []
    this.page = 1
  }
  render() {
    const searchPlaceholder = i18nTranslate(
      'subscription.searchPlaceholder',
      'Product Quick-Add'
    )
    const customWidth = this.props.isPvAssistPage ? 'col-md-9' : 'col-md-6'

    return (
      <>
        <div
          ref={this.setRef}
          className="subs-input-parent w-50 d-flex"
          onBlur={this.handleBoundaryBlur}>
          <Icons
            name="header-icons"
            icontype="search"
            width="13px"
            className="enable-search-icon"
            data-testid="qa-search-icon"
            ariaLabel={i18nTranslate('icons.searchicon', 'search icon', {
              nameSpace: 'ssr-resource',
            })}
            alt={i18nTranslate('icons.searchicon', 'search icon', {
              nameSpace: 'ssr-resource',
            })}
          />
          <Form.Control
            id="subscriptionSearchInput"
            type="text"
            className={`search-textBox bg-transparent `}
            data-testid="qa-search-add-button"
            placeholder={searchPlaceholder}
            onClick={async e => {
              nuskinSubscriptionContainer.collectAllSubscriptions()
            }}
            onChange={this.handleInputChange}
            autoComplete="off"
            value={this.inputValue}
            disabled={this.props.isPvAssistPage && !this.props.isPvActive}
            role="searchbox"
            aria-label="subscription search input"
          />
          {this.renderDropDown()}
        </div>
        {this.showSingleProductModal && (
          <SingleProductSubscriptionModal
            product={this.selectedProductDetails}
            isSubscribedBefore={true}
            isSignedUser={true}
            onUserSubscribe={this.doSubscribe}
            show={this.showSingleProductModal}
            onHide={this.toggleSingleSubscribeProductModal}
            enablePDPNavigation={true}
          />
        )}
      </>
    )
  }
}

export default SubscriptionInfiniteScroll
export { SubscriptionInfiniteScroll }
